globalThis.backoffice = globalThis.backoffice || {};

backoffice.ContactQualification = (function() {
    function contactQualification($form) {
        this.$form = $form;
        this.initForm();
    }

    contactQualification.prototype = {
        initForm: function() {
            this.$form.find('[data-popup="tooltip"]').tooltip();
            backoffice.initSelect2(this.$form.find('.select'));
            new FormAutosave(this.$form, {
                callbacks: {
                    success: function() {
                        this.$form.find('.saved').text(`Dernière sauvegarde le ${moment().format('DD/MM/YYYY à HH:mm')}`);
                    }
                }
            });
        }
    }

    return contactQualification;
})();
